import React, { useContext } from 'react'
import { DF_LO0003Context } from '../context'

export default function  GridFooter() {

  const { gridComponents } = useContext(DF_LO0003Context)

  function hasScroll() {
    const hasVerticalScroll = document.documentElement.scrollHeight > window.innerHeight;
    const hasHorizontalScroll = document.documentElement.scrollWidth > window.innerWidth;

    return {
      vertical: hasVerticalScroll,
      horizontal: hasHorizontalScroll
    };
  }
    
  let footerHtml = gridComponents?.FOOTER?.[0]?.Childrens?.find(
    c => c?.Chave_Transacao_Componente === 'FOOTER_CONTEUDO'
  )?.Valor_Componente


  if (typeof footerHtml !== 'string' || !footerHtml.trim()) return null

  return (
    
    <div style={{ position: (hasScroll().vertical ? 'absolute' : 'fixed'), bottom: -1, width: '-webkit-fill-available' }} dangerouslySetInnerHTML={{ __html: footerHtml }} />
  )
}

  